export default __webpack_public_path__ + "54f02d03d09280cd4ea4157cb01a1c5d.png";